export default function isLoading(auth = {}) {
  const { infoStatus, exitStatus, enterStatus } = auth;

  return infoStatus.loading || exitStatus.loading || enterStatus.loading;
}
